import { render, staticRenderFns } from "./modal-participant-ugems.vue?vue&type=template&id=2dc70b4e&scoped=true"
import script from "./modal-participant-ugems.vue?vue&type=script&lang=js"
export * from "./modal-participant-ugems.vue?vue&type=script&lang=js"
import style0 from "./modal-participant-ugems.vue?vue&type=style&index=0&id=2dc70b4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc70b4e",
  null
  
)

export default component.exports